import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor as Interceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HttpInterceptor implements Interceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let request;
    if (
      (
        req.url.includes('assets/i18n') ||
        req.url.includes('assets/countries.json') ||
        req.url.includes('graphql') ||
        req.headers.has('X-Skip-To-CDN') ||
        req.url.includes('assets/locales.json'))
    ) {
      request = req.clone({
        url: req.url,
        headers: req.headers.has('X-Skip-To-CDN') ? req.headers.delete('X-Skip-To-CDN') : req.headers
      });
    } else {
      const LANG = this.translate.currentLang ?? this.translate.defaultLang;
      const headers = req.headers.append('Accept-Language', LANG);

      request = req.clone({url: `${environment.apiUrl}${req.url}`, headers});
    }
    return next.handle(request).pipe(map((e: HttpEvent<any>) => {
      if (e instanceof HttpResponse) {
        if (e.status === 401) {
          // this.router.navigateByUrl('/auth/login');
          throw new Error('invalid token');
        }
      }
      return e;
    }));
  }

  constructor(private router: Router, private translate: TranslateService) {
  }
}
